<template>
    <el-dialog v-model="visible" title="设置风机盘管运行功率" width="520px" append-to-body :close-on-click-modal="false">
        <el-form ref="formRef" :model="form" label-width="120px" style="margin-top: 10px">
            <!-- 隐藏ID -->
            <el-input v-model="form.id" type="hidden" />
            <el-form-item label="区域" prop="name">
                <span>{{ building.name }}</span>
            </el-form-item>

            <el-form-item label="高档运行功率" prop="high_power" required>
                <el-input-number
                    v-model="form.high_power"
                    :min="0"
                    :precision="0"
                    placeholder="请输入高档功率"
                    style="width: 100%"
                />
            </el-form-item>

            <el-form-item label="中档运行功率" prop="mid_power" required>
                <el-input-number
                    v-model="form.mid_power"
                    :min="0"
                    :precision="0"
                    placeholder="请输入中档功率"
                    style="width: 100%"
                />
            </el-form-item>

            <el-form-item label="低档运行功率" prop="low_power" required>
                <el-input-number
                    v-model="form.low_power"
                    :min="0"
                    :precision="0"
                    placeholder="请输入低档功率"
                    style="width: 100%"
                />
            </el-form-item>
        </el-form>

        <template #footer>
            <div class="text-right">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="submit">确认</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { setFCUPower } from '@/api/building'

const visible = ref(false)
const formRef = ref(null)

const form = reactive({
    id: '',
    high_power: 0,
    mid_power: 0,
    low_power: 0
})

const emit = defineEmits(['success'])
const building = ref(null)
// 打开弹窗
function open(row = {}) {
    visible.value = true
    building.value = row
    form.id = row.id || ''
    form.high_power = row.high_power ?? 0
    form.mid_power = row.mid_power ?? 0
    form.low_power = row.low_power ?? 0
}

// 提交
async function submit() {
    if (form.high_power < 0 || form.mid_power < 0 || form.low_power < 0) {
        ElMessage.warning('功率不能小于0')
        return
    }
    await setFCUPower(form)
    emit('success', { ...form })
    ElMessage.success('设置成功')
    visible.value = false
}

defineExpose({ open })
</script>

<style scoped>
.text-right {
    text-align: right;
}
</style>
